import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { useEmpresaStore } from '@/store/empresaStore';
import styles from '@/styles/ui.module.css';

interface AppHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  showActions?: boolean;
}

export default function AppHeader({
  title,
  subtitle,
  showBack = true,
  showActions = true,
}: AppHeaderProps) {
  const navigate = useNavigate();
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const clearEmpresa = useEmpresaStore((state) => state.clearEmpresa);

  const handleLogout = () => {
    clearAuth();
    clearEmpresa();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <header className={styles.screenHeader}>
        <div className={styles.screenHeaderInner}>
          <div className={styles.headerRow}>
            {showBack && (
              <button onClick={() => navigate(-1)} className={styles.headerButton} type="button" aria-label="Volver">
                <span className="material-symbols-outlined">arrow_back</span>
              </button>
            )}
            <div className={styles.headerText}>
              <h2 className={styles.layoutHeaderTitle}>{title}</h2>
              {subtitle && <p className={styles.layoutHeaderSubtitle}>{subtitle}</p>}
            </div>
          </div>
          {showActions && (
            <div className={`${styles.layoutRightAction} ${styles.headerDesktopActions}`}>
              <button
                onClick={() => navigate('/pedidos')}
                className={styles.headerActionButton}
                type="button"
              >
                Mis pedidos
              </button>
              <button onClick={handleLogout} className={styles.headerActionButton} type="button">
                Cerrar sesion
              </button>
            </div>
          )}
        </div>
      </header>
      {showActions && (
        <div className={styles.headerMobileFooter}>
          <div className={styles.headerMobileFooterInner}>
            <button onClick={() => navigate('/pedidos')} className={styles.headerMobileActionButton} type="button">
              Mis pedidos
            </button>
            <button onClick={handleLogout} className={styles.headerMobileActionButton} type="button">
              Cerrar sesion
            </button>
          </div>
        </div>
      )}
    </>
  );
}
